import {ICellRendererParams} from "@ag-grid-community/core";
import {Text, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {ManifestStop} from "../../../generated/graphql";
const ContactContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ContactValueGetter = (params: ICellRendererParams<ManifestStop, string | undefined>) => {
  const contactInfo = [];
  const see = params.data?.see;
  const phone = params.data?.phone;
  if (!see && !phone) return "";
  if (see) contactInfo.push(see);
  if (phone) contactInfo.push(phone);
  return contactInfo.join(" - ");
};

export const ContactCellRenderer = (props: ICellRendererParams) => {
  return (
    <Tooltip fill placement={"top-start"} content={props.value}>
      <ContactContainer>
        <Text ellipsize={true}>{props.value}</Text>
      </ContactContainer>
    </Tooltip>
  );
};
